module.exports = __webpack_public_path__ + "static/media/ME.f5cede42.png";